import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const TiposCombustible = ({ usuario, onLogout }) => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ nombre: '', precio_galon: '' });

  const esAdmin = usuario?.rol === 'admin';

  const cargar = useCallback(async () => {
    setLoading(true);
    try { const res = await api.get('/tipos-combustible'); setTipos(res.data); }
    catch { setError('Error cargando tipos de combustible'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const resetForm = () => { setForm({ nombre: '', precio_galon: '' }); setEditando(null); setShowForm(false); setError(''); };
  const abrirEditar = (t) => { setForm({ nombre: t.nombre, precio_galon: t.precio_galon }); setEditando(t.id); setShowForm(true); };

  const guardar = async (e) => {
    e.preventDefault(); setError('');
    try {
      editando ? await api.put(`/tipos-combustible/${editando}`, form) : await api.post('/tipos-combustible', form);
      resetForm(); cargar();
    } catch (err) { setError(err.response?.data?.detail || 'Error guardando tipo'); }
  };

  const eliminar = async (id) => { if (!window.confirm('¿Desactivar este tipo?')) return; try { await api.delete(`/tipos-combustible/${id}`); cargar(); } catch { setError('Error'); } };

  const ICONOS = { gasoil: '🛢️', gasolina: '⛽', keroseno: '🔥' };
  const activos = tipos.filter(t => t.activo);

  return (
    <Layout usuario={usuario} onLogout={onLogout} title="Tipos de Combustible">
      <div style={S.headerRow}>
        <p style={S.subtitle}>Tipos de combustible y precio por galón</p>
        {esAdmin && <button style={S.btnAdd} onClick={() => setShowForm(true)}>+ Nuevo Tipo</button>}
      </div>
      {error && <div style={S.error}>{error}</div>}
      {showForm && (
        <div style={S.formCard}>
          <h3 style={S.formTitle}>{editando ? 'Editar Tipo' : 'Nuevo Tipo de Combustible'}</h3>
          <form onSubmit={guardar} style={S.form}>
            <div style={S.formGrid}>
              <div style={S.group}>
                <label style={S.label}>Nombre *</label>
                <input style={S.input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} placeholder="Ej: Gasoil" required />
              </div>
              <div style={S.group}>
                <label style={S.label}>Precio por galón (RD$) *</label>
                <input style={S.input} type="number" step="0.01" min="0" value={form.precio_galon} onChange={e => setForm({ ...form, precio_galon: e.target.value })} placeholder="Ej: 285.50" required />
              </div>
            </div>
            <div style={S.formBtns}>
              <button type="button" style={S.btnCancel} onClick={resetForm}>Cancelar</button>
              <button type="submit" style={S.btnSave}>{editando ? 'Guardar' : 'Crear Tipo'}</button>
            </div>
          </form>
        </div>
      )}
      {loading ? <div style={S.loading}>Cargando...</div> : activos.length === 0 ? (
        <div style={S.empty}><div style={{ fontSize: '48px' }}>⛽</div><p>No hay tipos de combustible registrados.</p></div>
      ) : (
        <div style={S.grid}>
          {activos.map(t => (
            <div key={t.id} style={S.card}>
              <div style={S.cardIcon}>{ICONOS[t.nombre.toLowerCase()] || '⛽'}</div>
              <div style={S.cardNombre}>{t.nombre}</div>
              <div style={S.cardPrecio}>RD$ {Number(t.precio_galon).toLocaleString('es-DO', { minimumFractionDigits: 2 })}<span style={S.cardPrecioLabel}>/galón</span></div>
              {esAdmin && (
                <div style={S.cardBtns}>
                  <button style={S.btnEdit} onClick={() => abrirEditar(t)}>✏️ Editar precio</button>
                  <button style={S.btnDel} onClick={() => eliminar(t.id)}>🗑️</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

const S = {
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' },
  subtitle: { color: '#888', fontSize: '13px', margin: 0 },
  btnAdd: { background: '#CC0000', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', color: '#CC0000', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  formCard: { background: '#fff', borderRadius: '12px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' },
  formTitle: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 16px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  group: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#555' },
  input: { padding: '10px 12px', borderRadius: '7px', border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none', color: '#1a1a1a' },
  formBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  btnCancel: { padding: '10px 20px', borderRadius: '7px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  btnSave: { padding: '10px 20px', borderRadius: '7px', border: 'none', background: '#CC0000', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  loading: { textAlign: 'center', padding: '60px', color: '#666' },
  empty: { textAlign: 'center', padding: '60px', color: '#999', background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' },
  card: { background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' },
  cardIcon: { fontSize: '40px', marginBottom: '10px' },
  cardNombre: { fontSize: '16px', fontWeight: '800', color: '#1a1a1a', marginBottom: '8px', textTransform: 'capitalize' },
  cardPrecio: { fontSize: '22px', fontWeight: '800', color: '#CC0000', marginBottom: '14px' },
  cardPrecioLabel: { fontSize: '12px', color: '#888', fontWeight: '400' },
  cardBtns: { display: 'flex', gap: '6px' },
  btnEdit: { flex: 1, padding: '7px', borderRadius: '6px', border: '1.5px solid #e0e0e0', background: '#fff', fontSize: '11px', fontWeight: '600', cursor: 'pointer', color: '#333' },
  btnDel: { padding: '7px 10px', borderRadius: '6px', border: 'none', background: '#fff0f0', cursor: 'pointer', fontSize: '14px' },
};

export default TiposCombustible;
